import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import atualizalocal from './modules/atualizalocal';
import auth from './modules/auth';
import users from './modules/users';
import empresa from './modules/empresa';
import permissao from './modules/permissao';
import modulos from './modules/modulos';
import cache from './modules/cache';
import vendedor from './modules/vendedor';
import cliente from './modules/cliente';
import destinoitemvenda from './modules/destinoitemvenda';
import financeiro from './modules/financeiro';
import formapagto from './modules/formapagto';
import pedido from './modules/pedido';
import pedidoitem from './modules/pedidoitem';
import planopagamento from './modules/planopagamento';
import produtosugerido from './modules/produtosugerido';
import tipopedidovenda from './modules/tipopedidovenda';
import venda from './modules/venda';
import visita from './modules/visita';
import produto from './modules/produto';
import filter from './modules/filter';
// import debug from './modules/debug';

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    async $_setup({ dispatch }) {
      await dispatch('auth/$_setup');
    },
  },

  modules: {
    atualizalocal,
    auth,
    users,
    empresa,
    permissao,
    modulos,
    cache,
    vendedor,
    cliente,
    destinoitemvenda,
    financeiro,
    formapagto,
    pedido,
    pedidoitem,
    planopagamento,
    produto,
    produtosugerido,
    tipopedidovenda,
    venda,
    visita,
    filter,
    //debug
  }, 
  plugins: [createPersistedState({
    paths: ['ordemcarregamento'],
    storage: window.sessionStorage,
  })],
});
